import { __decorate } from "tslib";
/* eslint-disable prefer-const */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SailsSocketService } from '../../modules/sails-socket';
let RulesService = class RulesService {
    sails;
    constructor(sails) {
        this.sails = sails;
    }
    getRules(pack) {
        return new Observable((subscriber) => {
            let subscription;
            subscription = this.sails.get(`/rule${pack ? `?pack=${pack}` : ''}`)
                .subscribe((msg) => {
                subscriber.next(msg);
                subscriber.complete();
            }, (error) => {
                subscriber.error(error);
            });
            return {
                unsubscribe() {
                    if (subscription) {
                        subscription.unsubscribe();
                    }
                }
            };
        });
    }
    setRule(updatedRule) {
        return new Observable((subscriber) => {
            let subscription;
            subscription = this.sails.put('/rule', updatedRule)
                .subscribe((msg) => {
                subscriber.next(msg);
                subscriber.complete();
            }, (error) => {
                subscriber.error(error);
            });
            return {
                unsubscribe() {
                    if (subscription) {
                        subscription.unsubscribe();
                    }
                }
            };
        });
    }
    createRule(newRule) {
        return new Observable((subscriber) => {
            let subscription;
            subscription = this.sails.post('/rule', newRule)
                .subscribe((msg) => {
                subscriber.next(msg);
                subscriber.complete();
            }, (error) => {
                subscriber.error(error);
            });
            return {
                unsubscribe() {
                    if (subscription) {
                        subscription.unsubscribe();
                    }
                }
            };
        });
    }
    deleteRule(id) {
        return new Observable((subscriber) => {
            let subscription;
            subscription = this.sails.delete(`/rule/${id}`)
                .subscribe((msg) => {
                subscriber.next(msg);
                subscriber.complete();
            });
            return {
                unsubscribe() {
                    if (subscription) {
                        subscription.unsubscribe();
                    }
                }
            };
        });
    }
    getActions(pack) {
        return new Observable((subscriber) => {
            let subscription;
            subscription = this.sails.get(`/action${pack ? `?pack=${pack}` : ''}`)
                .subscribe((msg) => {
                subscriber.next(msg);
                subscriber.complete();
            });
            return {
                unsubscribe() {
                    if (subscription) {
                        subscription.unsubscribe();
                    }
                }
            };
        });
    }
    static ctorParameters = () => [
        { type: SailsSocketService }
    ];
};
RulesService = __decorate([
    Injectable({
        providedIn: 'root'
    })
], RulesService);
export { RulesService };
